export default {
  noEmail: {
    id: 'LIST_ENTRY_WITH_AVATAR_NO_EMAIL',
    description: 'Text for contacts with no email',
    defaultMessage: 'No Email',
  },
};
